import React, { useState, useRef, useEffect } from "react"
import * as Icon from "react-feather"

import { StaticQuery, graphql } from "gatsby"
import ReactCountryFlag from "react-country-flag"
import { DropdownListItem } from "./DropdownListItem"
import {
  StyledDropdownContainer,
  StyledDropDownListContainer,
  StyledDropDownHeader,
  StyledFlagContainer,
} from "./partials"
import IconV2 from "../icon-v2"

const GetOptions = ({ slug, onClickHandler }) => (
  <StaticQuery
    query={graphql`
      query {
        allStoryblokDatasourceEntry {
          edges {
            node {
              id
              name
              value
              data_source
            }
          }
        }
      }
    `}
    render={(data) => {
      let options = (
        <React.Fragment>
          <></>
        </React.Fragment>
      )

      if (data && data.allStoryblokDatasourceEntry) {
        options = (
          <React.Fragment>
            {data.allStoryblokDatasourceEntry?.edges.map((o) => {
              if (o.node.data_source === slug) {
                return (
                  <DropdownListItem
                    key={o.node.id}
                    onItemClick={(_) => onClickHandler(o.node)}
                  >
                    <StyledFlagContainer>
                      <ReactCountryFlag
                        countryCode={o.node.name.substring(0, 2)}
                        aria-label={o.node.name}
                        svg
                      />
                      <span>{o.node.name.substring(3)}</span>
                      <span>&nbsp;{"(" + o.node.value + ")"}</span>
                    </StyledFlagContainer>
                  </DropdownListItem>
                )
              }
            })}
          </React.Fragment>
        )
      }
      return options
    }}
  />
)

export const TelephoneDropdown = ({
  countryCode = "+1",
  onChange,
  valid,
  isDark,
  isoCountry = "US",
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const myRef = useRef()

  function toggleList() {
    setIsOpen(!isOpen)
  }

  function handleClick(e) {
    onChange({ countryCode: e.value, isoCountry: e.name.substring(0, 2) })
    setIsOpen(false)
  }

  const handleClickOutside = (e) => {
    if (!myRef?.current?.contains(e.target)) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  })

  return (
    <StyledDropdownContainer isDark={isDark} valid={valid}>
      <StyledDropDownHeader onClick={toggleList}>
        {
          <StyledFlagContainer>
            <ReactCountryFlag
              countryCode={isoCountry}
              aria-label={isoCountry}
              svg
            />
            <p>{countryCode}</p>
          </StyledFlagContainer>
        }
        <IconV2 icon="angle-down" iconType="far" size="12" />
      </StyledDropDownHeader>
      {isOpen && (
        <StyledDropDownListContainer isDark={isDark} ref={myRef}>
          <ul>
            <GetOptions slug="form-phone-codes" onClickHandler={handleClick} />
          </ul>
        </StyledDropDownListContainer>
      )}
    </StyledDropdownContainer>
  )
}
